<template>
    <section class="formulaire-contact">

        <div class="wrapper">
            <h1 class="titre">Contactez-nous via notre formulaire de contact</h1>
            <transition name="slide-fade" mode="out-in">
                <div v-if="submitted" key="confirmation">
                    <h2 class="titre">Merci !</h2>
                    <p>Message envoyé</p>
                </div>

                <form @submit.prevent="submit" v-else key="form">
                    <div class="row">
                        <div class="col-12">
                            <custom-select v-model="form.title"
                                           :options="titles"
                                           value-field="value"
                                           class="civility-select"
                                           required>
                            </custom-select>
                            <p v-for="error in errors.get('title')">{{ error }}</p>
                        </div>

                        <div class="col-12 col-lg-6">
                            <floating-label label="Nom *" for="last-name">
                                <input type="text"
                                       id="last-name"
                                       v-model="form.lastName"
                                       required>
                            </floating-label>
                            <p v-for="error in errors.get('last_name')">{{ error }}</p>
                        </div>

                        <div class="col-12 col-lg-6">
                            <floating-label label="Prénom *" for="first-name">
                                <input type="text"
                                       id="first-name"
                                       v-model="form.firstName"
                                       required>
                            </floating-label>
                            <p v-for="error in errors.get('first_name')">{{ error }}</p>
                        </div>

                        <div class="col-12 col-lg-6">
                            <floating-label label="Email *" for="email">
                                <input type="email"
                                       id="email"
                                       v-model="form.email"
                                       required>
                            </floating-label>
                            <p v-for="error in errors.get('email')">{{ error }}</p>
                        </div>

                        <div class="col-12 col-lg-6">
                            <floating-label label="Téléphone *" for="tel">
                                <input type="text"
                                       id="tel"
                                       v-model="form.phoneNumber"
                                       required>
                            </floating-label>
                            <p v-for="error in errors.get('phone_number')">{{ error }}</p>
                        </div>

                        <div class="col-12 col-lg-6">
                            <custom-select v-model="form.origin"
                                           :options="origins"
                                           value-field="value"
                                           class="connu"
                                           required>
                            </custom-select>
                            <p v-for="error in errors.get('origin')">{{ error }}</p>
                        </div>

                        <div class="col-12 col-lg-6">
                            <custom-select v-model="form.subject"
                                           :options="subjects"
                                           value-field="value"
                                           class="sujet"
                                           required>
                            </custom-select>
                            <p v-for="error in errors.get('subject')">{{ error }}</p>
                        </div>

                        <div class="col-12">
                            <floating-label label="Message *" for="additional-infos" class="textarea infos">
                                <textarea id="additional-infos" v-model="form.message"></textarea>
                            </floating-label>
                            <p v-for="error in errors.get('message')">{{ error }}</p>
                        </div>

                        <div class="col-12">
                            <div class="checkbox">
                                <input type="checkbox"
                                       class="ge"
                                       id="newsletter"
                                       v-model="form.newsletter">
                                <label for="newsletter">Je souhaite recevoir les actualités de Grands Espaces</label>
                            </div>
                            <p v-for="error in errors.get('newsletter')">{{ error }}</p>
                        </div>

                        <div class="col-12">
                            <div class="checkbox">
                                <input type="checkbox"
                                       class="ge"
                                       id="rgpd"
                                       v-model="form.acceptDataProcessing"
                                       required>
                                <label for="rgpd">J'accepte que les informations saisies soient utilisées dans le cadre
                                    de ma demande d'informations et de la relation commerciale associée</label>
                            </div>
                            <p v-for="error in errors.get('accept_data_processing')">{{ error }}</p>
                        </div>
                    </div>

                    <div class="loader-spin" v-if="loading">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <button type="submit" class="btn chevron submit-form" v-else>
                        Envoyer
                    </button>
                </form>
            </transition>


        </div>
    </section>
</template>

<script>
    import Scrolling from '../libs/Scrolling';
    import ajaxForm from '../mixins/ajaxForm';

    export default {
        mixins: [ajaxForm],
        props: {
            origins: {
                type: Array,
                required: true,
            },
            subjects: {
                type: Array,
                required: true,
            },
        },
        data: () => ({
            titles: [
                {
                    label: 'Civilité *',
                    value: '',
                },
                {
                    label: 'Madame',
                    value: 'mrs',
                },
                {
                    label: 'Monsieur',
                    value: 'mr',
                },
            ],
            form: {
                title: '',
                origin: '',
                subject: '',
                acceptDataProcessing: false,
            },
        }),
        methods: {
            goToDevis() {
                if (this.subjects.findIndex(subject => subject.value === 'Demande de devis') !== -1) {
                    Scrolling.scrollTo('.formulaire-contact', 'easeOutQuint', 2000, 90);
                    this.form.subject = 'Demande de devis';
                }
            },
            goToHelp() {
                if (this.subjects.findIndex(subject => subject.value === 'Aide pour réserver') !== -1) {
                    Scrolling.scrollTo('.formulaire-contact', 'easeOutQuint', 2000, 90);
                    this.form.subject = 'Aide pour réserver';
                }
            },
            submit() {
                this.request('ge_contact_form', this.mapFields(this.form)).then(response => {
                    Scrolling.scrollTo('.formulaire-contact', 'easeOutQuint', 1500, 90);
                });
            },
            reset() {
                this.form = {
                    title: '',
                    origin: '',
                    subject: '',
                    acceptDataProcessing: false,
                };
            },
        },
        mounted() {
            if (this.$route.hash === '#demande-de-devis') {
                setTimeout(() => {
                    this.goToDevis();
                }, 1000);
            }
            if (this.$route.hash === '#aide-reservation') {
                setTimeout(() => {
                    this.goToHelp();
                }, 1000);
            }
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/ContactForm.vue